import * as CubeTree from '../../../cubeTree/index';
import * as UIToolkit from '../../../UIToolkit/layer/index';
import * as Toolkit from '../../../toolkit/index';
import CodiSystem from '../../../codiSystem/index';

function makeMoveTask(arrow: ShelfInsertArrow, dragGoods: CubeId[], transfer: Transfer): MoveTask {
    let result: MoveTask = {
        logic: [],
        physics: []
    };

    result.logic = makeLogicTask(arrow, dragGoods);

    return result;
}

function makeLogicTask(arrow: ShelfInsertArrow, dragCubes: CubeId[]): LogicMoveTask[] {
    // 目标点是层板中的组件
    if (CubeTree.isFreezer(arrow.target)) {
        return moveToShelfCube(arrow, dragCubes);
    }

    return [];
}

function moveToShelfCube(arrow: ShelfInsertArrow, dragCubes: CubeId[]): LogicMoveTask[] {
    let result: LogicMoveTask[] = [];

    dragCubes.forEach((cubeId: CubeId): void => {
        if (cubeId === arrow.target) {
            return;
        }
        let oldParent: CubeId|null = CubeTree.findParentIdByCubeId(cubeId);
        let insertTarget: CubeId|null = arrow.target;
        let oldBefore: CubeId|null = CubeTree.findNextCube(cubeId, dragCubes);

        if (arrow.direction === 'right') {
            insertTarget = CubeTree.findNextCube(arrow.target, dragCubes);
        }

        result.push({
            from: {
                parent: oldParent,
                moveTarget: cubeId,
                before: oldBefore
            },
            to: {
                parent: oldParent,
                moveTarget: cubeId,
                insertBefore: insertTarget
            }
        });
    });

    return result;
}

export {
    makeMoveTask
};
